import i18n from 'i18next';

export const buildLocationString = (event) => {
  const location = [
    event?.location?.area,
    event?.location?.city,
    event?.location?.district,
    event?.location?.street,
    event?.location?.house_number,
  ]
    .filter((v) => !!v)
    .join(', ');
  if (location.length === 0) return i18n.t('lunapoint:no_address');
  return location;
};
